import React, {Component} from "react";
import * as prosConnect from "../prodect/ProsConnect";
import {awaitGetAllUsersAndProjects} from "../prodect/ProjectManagement";

import {
    ROLE_ADMIN,
    ROLE_INSPECT,
    ROLE_REPAIR,
    ROLE_READER,
    ROLE_NONE,
    ROLE_UNKNOWN,
    STR_NO_VALUE,
    OBJ_STATE_PAS,
    ATTR_CUSTOMER_GROUP,
    getValidAttr,
    hasCustomerHeadMasterRole, ATTR_CUSTOMER_ADMIN_EMAILS,
} from "../prodect/ProsConnect";
import {prosLog, prosLogDt,  prosLogClearDt} from "../prodect/ProsConnect";
import {awaitLoadProjectObjects} from "../prodect/ProjectLoader"
import {
    prosMultiFilterText,
    PROS_SELECTED_COLOR, PROS_ALERT_COLOR, parseNamesAndEmails, whyEmailStringNotValid,
    renderPermissionElement,
    isValidEmail
} from "../prodect/ProsCommonUi";
import {
    prosPopupClose, prosPopupCloseAll,
    prosPopupOpenDynamic, prosPopupRender,
} from "../prodect/ProsPopup";
import {ATTR_AWS_PROJECT_ID, ATTR_USER_ROLE, ATTR_EMAIL, ATTR_TEXT,
    ATTR_OBJ_ID, ATTR_OBJ_TYPE, OBJ_TYPE_USER_ROLE, ATTR_OBJ_STATE, OBJ_STATE_CREATE} from "../prodect/ProsConnect";
import {OBJ_TYPE_PG_ROLE, PRJ_PERM_GROUPS, OBJ_TYPE_PRJ_PG, ATTR_PG_ROLE} from "../prodect/ProsConnect";
import {OBJ_TYPE_PG_USER} from "../prodect/ProsConnect";
import {prosLogErr} from "../prodect/ProsConnect";
import {OBJ_STATE_TO_DEL} from "../prodect/ProsConnect";
import {ATTR_UPDATED_MS_I} from "../prodect/ProsConnect";
import {OBJ_STATE_ACT} from "../prodect/ProsConnect";
import {currentTimeMs} from "../prodect/ProsConnect";
import {ATTR_PERM_GROUP} from "../prodect/ProsConnect";
import { v4 as uuidv4 } from 'uuid';
import {
    PermissionsTable,
    getRoleForTableUi,
    getRoleSortOrder,
    getItmRoleSortOrder
} from "./PermissionsTable";
import {setHelpContext} from "../prodect/HelpManager";
import LoadingAnimation from "../components/LoadingAnimation";
import TextInput, {TimerTextInput} from "../components/TextInput";
import RadioButton from "../components/RadioButton";
import BasicButton, {CancelButton, ConfirmButton} from "../components/BasicButton";
import Spacer from "../components/Spacer";
import TabsNavigation from "../components/TabsNavigation";
import prosAppNotif, {prosAppNotifWarn, prosAppNotifWarnConfirm} from "../prodect/ProsAppNotif";


const ATTR_ALLOWED_EMAIL_DOMAINS = 'allowed_email_domains'
const ALL_SUBPROJECTS = "KAIKKI OSAPROJEKTIT";

const PROJ_PREFIX = "proj_";
const GROUP_PREFIX = "group_";
const NAME_COL_TITLE = "Nimi";
const NAME_COL_PG_NAME = "Ryhmän nimi";
const EMAIL_COL_TITLE = "Sähköposti";

const STYLE_NORMAL = {};
const STYLE_MODIFIED = {backgroundColor:PROS_SELECTED_COLOR};

const STYLE_IN_GROUP = {
    textAlign: "center",
    fontWeight: "bold"
};
const STYLE_IN_GROUP_MODIFIED = {
    textAlign: "center",
    backgroundColor:PROS_SELECTED_COLOR,
    fontWeight: "500"
};


const STYLE_ERROR = {textAlign: "center", color:PROS_ALERT_COLOR};

const COL_WIDTH_NAME = 160
const COL_WIDTH_EMAIL = 260

const MIN_NAME_LEN = 3;

const USER_ASSIGNED_TO_GROUP = <i className={"ui-icon ui-icon-xs ui-icon_color-light ui-icon-check"} />
const USER_NOT_ASSIGNED_TO_GROUP = <i className={"ui-icon ui-icon-xs ui-icon-disc"} />

const MAIN_VIEW_MODE_USER_PERMISSIONS = 1;
const MAIN_VIEW_MODE_GROUP_PERMISSIONS = 2;
const MAIN_VIEW_MODE_GROUP_USERS = 3;

const ATTR_PG_ROLE_FROM_DEPRECATED = "pg_from";
const ATTR_UI_PG = "ui_pg";
const PID_ALL = 'ALL'

const UI_NO_ROLE = '-'

export default class PermissionManagement extends Component {
    // ref project list in esim-tietorakenteet/pros-dbg-users-and-projects
    userList = [];  // { "email": "jussi.juonio@firma.fi", "name": "Jussi" }
    allProjects = [];
    /* objects - example:
            {
            "mainProjectName": "SW test",
            "projectName": "text",
            "projectId": "017d14d0-9d67-462a-8b0b-8432610bc7df",
            "userListId": "users-017d14d0-9d67-462a-8b0b-8432610bc7df",
            "obj_state": "PAS",
            "users": [
                {
                    "project_id": "017d14d0-9d67-462a-8b0b-8432610bc7df",
                    "obj_id": "users-017d14d0-9d67-462a-8b0b-8432610bc7df_23_1681",
                    "obj_type": "itm_user_role",
                    "text": "Tero Mx",
                    "user_role": "role_admin",
                    "email": "tero.nivala@gmail.com",
                    ...
                }
            ]
        }
    */

    projects = []

    usersGroups = []; // { "name": "x", "email": "x", "group_<ind>": [ "+" or "-"] }

    permGroups = [];
        // "project_id": "perm_groups"
        // "obj_id": <customer_group>;<GPID>
        // "obj_type": "prj_pg"
        // "text": "group name"

    pgRoles = [];
        //  "project_id": <PID>
        //  "obj_id": <USERS_LIST_ID>_<dev>_<ms>
        //  "perm_group": <GPID>
        //  "obj_type": "itm_pg_role"
        //  "pg_role": "role_repair"

    pgUsers = [];
        //  "project_id": "perm_groups"
        //  "obj_id": <customer_group><GPID><id>
        //  "obj_type": "itm_pg_user"
        //  "for_user": <email>

    userRoleList = [];    // { "email": "xx", "name": "xx", "origName":"xx", "proj_<ind>": { user role obj ... }
    pgRoleList = [];      // { "name": "xx", "origName":"xx", obj_id:<GPID>  "proj_<ind>": { group role obj ... }

    savedGroupOriginal = {};

    constructor(props) {
        super(props);
        this.state = {
            isLoading: true,
            isSaving: false,
            promptEmail: "",
            promptName: "",
            currentValue: "",
            rowInfo: "",
            projectName: "",
            index: undefined,
            columnId: undefined,
            refresh: 0,
            mainViewMode: this.props.showGroupsOnly ? MAIN_VIEW_MODE_GROUP_USERS : MAIN_VIEW_MODE_USER_PERMISSIONS,
            folded: {},
            filterTextInput: '',
            userHasModified: false,
            multipleUsersText: '',
            errorInUserList: undefined
        };
        this.showMenuPromptRole = this.showMenuPromptRole.bind(this);
        this.giveNewRole = this.giveNewRole.bind(this);
        this.saveChanges = this.saveChanges.bind(this);
        this.handleEmailName = this.handleEmailName.bind(this);
        this.handlePromptName = this.handlePromptName.bind(this);
        this.renderName = this.renderName.bind(this)
        this.renderEmail = this.renderEmail.bind(this)
    }

    async loadProjectPermissions() {
        if (prosConnect.getActiveProjectID() !== this.props.subProjectId) {
            this.setState({ isLoading: true })
            await awaitLoadProjectObjects(this.props.subProjectId)
        }
        let project = prosConnect.getActiveProject()
        if (project && this.hasAuthority()) {
            this.customerGroup = project.getAttr(ATTR_CUSTOMER_GROUP)
            await this.getProjectsUsersAndGroups()
        }
        // this.dumpUserPermissions();
        this.setState({
            isLoading: false,
        })
    }

    async componentDidMount() {
        await this.loadProjectPermissions()
        setHelpContext('admin')
    }

    async componentDidUpdate(prevProps, prevState) {
        if (prevProps.subProjectId !== this.props.subProjectId) {
            await this.loadProjectPermissions()
        }
    }

    componentWillUnmount() {
        prosPopupCloseAll()
    }

    hasAuthority() {
        let project = prosConnect.getActiveProject();
        if (project && prosConnect.hasPermissionTo("editAdmin", undefined, undefined, false)) {
            return true;
        } else {
            prosLog("Ei oikeuksia muokata käyttöoikeuksia");
            return false;
        }
    }

    makeProjectList() {
        let firstColumnAllProjects = {
            mainProjectName: prosConnect.getActiveMainProjectName().toUpperCase(),
            projectName: ALL_SUBPROJECTS,
            'projectId': PID_ALL,
        }
        this.projects = [firstColumnAllProjects].concat(this.allProjects
            .filter(project =>
                project.mainProjectName.toUpperCase() === prosConnect.getActiveMainProjectName().toUpperCase()))
        this.projects.forEach((project, i) => project.id = PROJ_PREFIX + i)
    }

    // Set project status "show" by a text filter
    filterProjects() {
        if (this.props.showSingleSubProject) {
            this.projects.forEach(project => {
                project.show = project.projectId === prosConnect.getActiveProjectID()
            })
            return
        }
        // Showing all project - check first which project match with a text filter
        let projectsVisibleCount = 0
        this.projects.forEach( project => {
            if (project.projectId !== PID_ALL) {
                project.show = prosMultiFilterText(this.state.filterTextInput, project.projectName);
                if (project.show) { projectsVisibleCount++ }
            }
        })
        // Make all column visible when have more than one matching text filter
        this.projects[0].show = projectsVisibleCount > 1
    }

    getSingleProjectColumnId() {
        let showingProjects = this.projects.filter( project => project.show && project.projectId !== PID_ALL)
        return showingProjects.length === 1 ? showingProjects[0].id : undefined
    }

    makePgObj(project, group) {
        let unknownPg = {};
        let pid = project.projectId;
        let userListOid = prosConnect.getProjectUsersListId(pid);
        unknownPg[ATTR_AWS_PROJECT_ID] = pid;
        unknownPg[ATTR_OBJ_ID] = prosConnect.makeNewObjId(userListOid);
        unknownPg[ATTR_OBJ_TYPE] = OBJ_TYPE_PG_ROLE;
        unknownPg[ATTR_OBJ_STATE] = OBJ_STATE_CREATE;
        unknownPg[ATTR_PG_ROLE] = ROLE_UNKNOWN;
        unknownPg[ATTR_PERM_GROUP] = group[ATTR_OBJ_ID];
        return unknownPg
    }

    addPgRoleToList(pgRow, isNew) {
        let minRole;
        this.allProjects.forEach((project, index) => {
            let pgRoleForProject;
            if (!isNew) {
                pgRoleForProject = this.pgRoles.find(pgRole =>
                    pgRole[ATTR_PERM_GROUP] === pgRow[ATTR_OBJ_ID] &&
                    pgRole[ATTR_AWS_PROJECT_ID] === project.projectId
                );
            }
            if (pgRoleForProject) {
                if (minRole === undefined || getRoleSortOrder(minRole) < getRoleSortOrder(pgRoleForProject[ATTR_PG_ROLE])) {
                    minRole = pgRoleForProject[ATTR_PG_ROLE];
                }
            } else {
                pgRoleForProject = this.makePgObj(project, pgRow);
                minRole = ROLE_UNKNOWN;
            }
            if (!isNew) {
                pgRoleForProject.ui_origRole = pgRoleForProject[ATTR_PG_ROLE];
            }
            pgRow[PROJ_PREFIX + (index+1)] = pgRoleForProject;
        });
        // set column 0 "ALL projects" role as minimum of PG's
        let allProjectsRoleObj = {}
        allProjectsRoleObj[ATTR_AWS_PROJECT_ID] = PID_ALL
        allProjectsRoleObj[ATTR_PG_ROLE] = minRole ? minRole: ROLE_UNKNOWN
        pgRow[PROJ_PREFIX + '0'] = allProjectsRoleObj
        this.pgRoleList.push(pgRow);
    }

    // dumpPgRoles(pgRoles) {
    //     pgRoles.forEach( pgRole => {
    //         console.log(pgRole[ATTR_AWS_PROJECT_ID], pgRole[ATTR_PG_ROLE]);
    //     })
    // }

    makePgProjects() {
        this.pgRoles.length = 0;
        this.allProjects.forEach((project, index) => {
            project.users.forEach( roleObj => {
                if (roleObj[ATTR_OBJ_TYPE] === OBJ_TYPE_PG_ROLE) {
                    this.pgRoles.push(roleObj);
                }
            })
        });
        // this.dumpPgRoles(this.pgRoles);

        this.pgRoleList.length = 0;
        this.permGroups.forEach(pg => {
            let pgRow = {
                name: pg.text,
                origName: pg.text
            };
            pgRow[ATTR_OBJ_ID] = pg[ATTR_OBJ_ID];
            this.addPgRoleToList(pgRow, false);
        });
    }

    findUserGroupObj(email, gpid) {
        for (let pgUser of this.pgUsers) {
            if (pgUser[ATTR_OBJ_ID].indexOf(gpid) === 0 &&
                pgUser[ATTR_EMAIL] === email) {
                return pgUser;
            }
        }
        return undefined;
    }

    userInPermissionGroup(email, pg) {
        let pgUser = this.findUserGroupObj(email, pg[ATTR_OBJ_ID]);
        if (pgUser && pgUser[ATTR_OBJ_STATE] !== OBJ_STATE_TO_DEL) {
            return pgUser;
        }
        return undefined;
    }

    removeObjFromList(lst, obj) {
        let index = lst.indexOf(obj);
        if (index >= 0) {
            lst.splice(index, 1);
        } else {
            prosLogErr("No obj to remove", obj);
        }
    }

    addUserGroupObj(email, groupObj) {
        let ug = {};
        ug[ATTR_AWS_PROJECT_ID] = PRJ_PERM_GROUPS;
        let gpid = groupObj[ATTR_PERM_GROUP];
        ug[ATTR_OBJ_ID] = gpid ? prosConnect.makeNewObjId(gpid) : 'group-id'
        ug[ATTR_EMAIL] = email;
        ug[ATTR_OBJ_TYPE] = OBJ_TYPE_PG_USER;
        ug[ATTR_OBJ_STATE] = OBJ_STATE_CREATE;
        ug[ATTR_UPDATED_MS_I] = currentTimeMs();
        this.pgUsers.push(ug);
    }

    updateUserInPgroup(email, groupObj, addUserToPermGroup) {
        let gpid = groupObj[ATTR_PERM_GROUP];
        let pgUser = this.findUserGroupObj(email, gpid);
        if (!pgUser) {
            // No user in perm group obj
            if (addUserToPermGroup) {
                this.addUserGroupObj(email, groupObj);
            }
            // else skip as missing already
            return;
        }
        // state can be
        //      CREATE - added in this session
        //      ACT - obj exists server - to be activated after removal in this session
        //      TO_DEL - obj exists server - marked as to be removed in this session
        if (addUserToPermGroup) {
            if (pgUser[ATTR_OBJ_STATE] === OBJ_STATE_TO_DEL) {
                pgUser[ATTR_OBJ_STATE] = OBJ_STATE_ACT;
                pgUser[ATTR_UPDATED_MS_I] = currentTimeMs();
            }
            // else skip as already ACT or CREATE
        } else {
            // remove if is
            if (pgUser[ATTR_OBJ_STATE] === OBJ_STATE_CREATE) {
                this.removeObjFromList(this.pgUsers, pgUser);
            } else if (pgUser[ATTR_OBJ_STATE] === OBJ_STATE_ACT) {
                pgUser[ATTR_OBJ_STATE] = OBJ_STATE_TO_DEL;
                pgUser[ATTR_UPDATED_MS_I] = currentTimeMs();
            }
        }
    }

    getUpdatedPgUsers() {
        let needUpdates = [];
        for (let pgUser of this.pgUsers) {
            if (pgUser[ATTR_UPDATED_MS_I] && pgUser[ATTR_OBJ_ID] !== 'group-id') {
                needUpdates.push(pgUser);
            }
        }
        return needUpdates;
    }

    makeUsersGroups() {
        this.usersGroups.length = 0;
        this.userList.forEach((user, rowIndex) => {
            let userGroupRow = {
                name: user.name,
                email: user.email,
            };
            this.permGroups.forEach((pg, colIndex) => {
                let val = this.userInPermissionGroup(user.email, pg) ?
                    USER_ASSIGNED_TO_GROUP :
                    USER_NOT_ASSIGNED_TO_GROUP;
                userGroupRow[GROUP_PREFIX + colIndex] = val;
                this.saveOriginalGroup(rowIndex, GROUP_PREFIX + colIndex, val);
            });
            this.usersGroups.push(userGroupRow);
        });
    }

    addUserToGroup() {
        let rowIndex = this.userList.length-1;
        let lastUser = this.userList[rowIndex];
        let userGroupRow = {
            name: lastUser.name,
            email: lastUser.email,
        };
        this.permGroups.forEach((pg,i) => {
            userGroupRow[GROUP_PREFIX + i] = USER_NOT_ASSIGNED_TO_GROUP;
            this.saveOriginalGroup(rowIndex, GROUP_PREFIX + i, USER_NOT_ASSIGNED_TO_GROUP);
        });
        this.usersGroups.push(userGroupRow);
    }


    async getProjectsUsersAndGroups() {
        let response = await awaitGetAllUsersAndProjects();
        if (response) {
            // dumpObjToJsonFile(response, 'project_permissions')
            this.userList = response.users;
            this.allProjects = response.projects;

            this.permGroups.length = 0;
            this.pgUsers.length = 0;
            if (response.hasOwnProperty('permGroupList')) {
                response.permGroupList.forEach(pgObj => {
                    delete(pgObj[ATTR_UPDATED_MS_I]); // updated to mark when modified
                    if (pgObj.hasOwnProperty(ATTR_PG_ROLE_FROM_DEPRECATED)) {
                        delete(pgObj[ATTR_PG_ROLE_FROM_DEPRECATED]);
                    }
                    switch(pgObj[ATTR_OBJ_TYPE]) {
                        case OBJ_TYPE_PRJ_PG:  this.permGroups.push(pgObj); break;
                        case OBJ_TYPE_PG_USER: this.pgUsers.push(pgObj);    break;
                        default: prosLogErr("Invalid pg obj", pgObj)
                    }
                });
            }
            // console.log ("permGroups.length", this.permGroups.length);
            // console.log ("pgUsers.length", this.pgUsers.length);
            this.makeProjectList();
            this.setUserProjects();
            this.makePgProjects();
            this.makeUsersGroups();
        }
        this.setState({
            isLoading: false,
            userHasModified: false
        });
        this.updateUserGroupPermissions();
    }

    makeUserObj(project, user) {
        let unknownUser = {};
        unknownUser[ATTR_USER_ROLE] = ROLE_UNKNOWN;
        unknownUser[ATTR_AWS_PROJECT_ID] = project.projectId;
        unknownUser[ATTR_EMAIL] = user.email;
        unknownUser[ATTR_TEXT] = user.name;
        unknownUser[ATTR_OBJ_TYPE] = OBJ_TYPE_USER_ROLE;
        unknownUser[ATTR_OBJ_STATE] = OBJ_STATE_CREATE;
        return unknownUser
    }

    addUserRoleToList(userRoles, isNew) {
        this.allProjects.forEach((project, index) => {
            // console.log('index', index, 'project', project)
            let userRoleForProject = project.users.find(userRole => userRole.email === userRoles.email);
            if (!userRoleForProject) {
                userRoleForProject = this.makeUserObj(project, userRoles);
            }
            if (!isNew) {
                userRoleForProject.ui_origRole = userRoleForProject[ATTR_USER_ROLE];
                userRoleForProject.ui_OrigText = userRoleForProject[ATTR_TEXT];
            }
            userRoles[PROJ_PREFIX + (index+1)] = userRoleForProject;
        });
        // set column 0 "ALL projects"
        let allProjectsRoleObj = {}
        allProjectsRoleObj[ATTR_AWS_PROJECT_ID] = PID_ALL
        allProjectsRoleObj[ATTR_USER_ROLE] = ROLE_UNKNOWN
        userRoles[PROJ_PREFIX + '0'] = allProjectsRoleObj
        this.userRoleList.push(userRoles)
    }

    setUserProjects() {
        this.userRoleList.length = 0;
        this.userList.forEach((user) => {
            let userRoles = {
                email: user.email,
                name: user.name,
                origName: user.name
            };
            this.addUserRoleToList(userRoles, false);
        });
    }

    filterRoleForUi(user_role, filter) {
        let roleUiStr = getRoleForTableUi(user_role).toLowerCase();
        if (filter.value === '' && roleUiStr === '') {
            return true;
        }
        let filters = filter.value.toLowerCase().split(',');
        for (let filter of filters) {
            let flt = filter.trim();
            if (filter !== '' && roleUiStr.includes(flt)) {
                return true
            }
        }
        return false
    }

    renderName (props) {
        if(this.state.mainViewMode === MAIN_VIEW_MODE_GROUP_USERS && props.cell.column.id === 'name') return <div>{props.value}</div>
        const { row } = props
        if (props.value) {
            let changed = false
            if (row.values && row.values.name &&
                row.original && row.original.name) {
                changed = row.values.name !== row.original.origName
            } else {
                return
            }
            return <div className={"element-set-xs"}>
                <p
                    style={changed ? STYLE_MODIFIED : STYLE_NORMAL}
                    > {props.value}
                </p>
                <BasicButton
                    size={"md"}
                    icon={"edit"}
                    action={() => {
                        this.showNameChangePopUp(row.index, row.values.email, row.values.name);
                    }}
                    title={"Muokkaa"}
                />
            </div>
        }
    }

    addUsersSharingVisibleProjects(emails, refUserIndex) {
        let changeCount = 0
        emails.forEach(email => {
            let userIndex = this.userRoleList.findIndex(user => user.email === email)
            if (userIndex >= 0) {
                Object.keys(this.userRoleList[refUserIndex]).forEach(projColumnId => {
                    let refProject = this.getProjectByColumnIdTo(projColumnId)
                    if (refProject) {
                        let refRoleObj = this.userRoleList[refUserIndex][projColumnId];
                        let refRole = refRoleObj[ATTR_USER_ROLE]
                        //console.log('Ref user role for', refProject.projectName, 'show:', refProject.show, 'roleObj:', refRoleObj)
                        //console.log('getRoleSortOrder(refRole):', getRoleSortOrder(refRole),'getRoleSortOrder(ROLE_NONE)', getRoleSortOrder(ROLE_NONE))
                        if (refRole && refProject.show && refProject.projectId !== PID_ALL &&
                            getRoleSortOrder(refRole) < getRoleSortOrder(ROLE_NONE)) {
                            if (this.applyRoleForSubproject(userIndex, projColumnId, refRole, false, false)) {
                                changeCount++
                            }
                        }
                    }
                });
            }
        })
        return changeCount
    }

    addUsersSharingVisibleGroups(emails, refUserIndex) {
        let changeCount = 0
        Object.keys(this.usersGroups[refUserIndex]).forEach(columnId => {
            if (this.usersGroups[refUserIndex][columnId] === USER_ASSIGNED_TO_GROUP) {
                emails.forEach(email => {
                    let userIndex = this.userRoleList.findIndex(user => user.email === email)
                    if (userIndex >= 0 && this.usersGroups[userIndex][columnId] !== USER_ASSIGNED_TO_GROUP) {
                        this.usersGroups[userIndex][columnId] = USER_ASSIGNED_TO_GROUP
                        changeCount++
                    }
                })
            }
        })
        this.updateUserGroupPermissions()
        return changeCount
    }


    handlAddMultipleUsers() {
        let refUserIndex = this.state.rowInfo.index
        if (refUserIndex < 0 || refUserIndex >= this.userRoleList.length ||
            this.userRoleList[refUserIndex].email !== this.state.rowInfo.email) {
            prosLogErr("Inconsistent rowInfo", this.state.row)
            this.closePopupAddMultipleUsers()
            return
        }
        // Get names and emails
        let users = parseNamesAndEmails(this.state.multipleUsersText)
        if (users.length < 1) {
            this.setState ({errorInUserList: "Ei yhtään nimeä ?"})
            return
        }
        // Validate email addresses
        let errorInEmail = ''
        let errornousEmail = users.find(user => {
            errorInEmail = this.getErrorInEmail(user.email)
            return errorInEmail !== ''
        })
        if (errornousEmail) {
            this.setState ({errorInUserList: "Virheellinen sähköposti: "
                    + errornousEmail.email
                    + ' (' + errorInEmail + ')'
            })
            return
        }
        // Add users that do not exist yet
        let addEmails = users.filter(user => !this.userRoleList.find(userRole => user.email === userRole.email))
        addEmails.forEach(user => this.createNewUser(user))

        let emails = users.map(user => user.email)
        let changeCount = this.state.mainViewMode === MAIN_VIEW_MODE_USER_PERMISSIONS ?
                this.addUsersSharingVisibleProjects(emails, refUserIndex):
                this.addUsersSharingVisibleGroups(emails, refUserIndex)

        if (changeCount) {
            prosAppNotif("Käyttöoikeuksia lisätty "
                + changeCount + ", tarkista vielä ennen tallennusta", false, true)
        } else {
            prosAppNotif("Ei muutoksia käyttöoikeuksiin", false, true)
        }
        this.closePopupAddMultipleUsers()
    }

    validateUserList(val) {
        let newText = val.replace(/[?!:<>{}]/g, '');
        this.setState({
            multipleUsersText: newText,
            errorInUserList: undefined
        })
    }

    renderErrorInUserList() {
            if (this.state.errorInUserList) {
                return <p><strong>{this.state.errorInUserList}</strong></p>
            }
    }

    closePopupAddMultipleUsers() {
        this.setState({
            errorInUserList: undefined,
            multipleUsersText: ''
        })
    }

    returnPopupAddMultipleUsers() {
        let note = this.state.mainViewMode === MAIN_VIEW_MODE_USER_PERMISSIONS ?
            "Lisää näkyviin projekteihin käyttäjiä samoilla käyttöoikeuksilla kuin":
            "Lisää käyttäjiä näkyviin samoihin ryhmiin kuin"

        return <>
            <section>
                {note}
                <strong>&nbsp;{this.state.rowInfo.email}</strong>
                <TextInput
                    multiline={5}
                    value={this.state.multipleUsersText}
                    autoFocus
                    onChange={val => this.validateUserList(val)}
                />
                {this.renderErrorInUserList()}
                <p> Yksi tai useampia nimiä (optio) ja sähköpostiosotteita, muoto:</p>
                <p> - email, email, .. - tai</p>
                <p> - nimi, email; nimi, email; ..</p>
            </section>
            <footer className={"popup-footer"}>
                <div className={"btn-set"}>
                    <ConfirmButton
                        label={"Lisää käyttöoikeuksia"}
                        action={()=> this.handlAddMultipleUsers()}
                    />
                </div>
            </footer>
        </>
    }

    showPopupAddMultipleUsers(index, email) {
        this.setState({
            rowInfo:{ email: email, index: index },
            multipleUsersText: '',
        })
        prosPopupOpenDynamic(this,
            'Käyttäjien tai käyttöoikeuksien lisääminen',
            () => this.returnPopupAddMultipleUsers(this),
            () => this.closePopupAddMultipleUsers(this)
        )
    }

    hasRowPermissionForSomeProject(columns) {
        for (let column of Object.keys(columns)) {
            if (column.indexOf(PROJ_PREFIX) === 0) {
                let proj = columns[column]
                if (this.hasRole(proj[ATTR_USER_ROLE])) {
                    return true
                }
            }
        }
        return false
    }

    renderEmail(props) {
        const { row } = props
        let title = this.state.mainViewMode === MAIN_VIEW_MODE_USER_PERMISSIONS ?
                "Lisää käyttäjiä kopioimalla oikeudet":
                "Lisää käyttäjiä samoihin käyttöoikeusryhmiin"
        if (props.value) {
            let copyUserPermissionsButton = this.hasRowPermissionForSomeProject(row.values) ?
                <BasicButton
                    icon={"user-add"}
                    size={"md"}
                    action={() => this.showPopupAddMultipleUsers(row.index, row.values.email)}
                    title={title}
                />
                : null
            if (row.values && row.values.email) {
                return <div className={"element-set-xs"}>
                        <p>{props.value}</p>
                    <>{copyUserPermissionsButton}</>
                    </div>
            }
        }
    }


    renderRole =(key)=> {

            if (!key || !key.value) {
                return UI_NO_ROLE
            }

        let role = key.value[ATTR_USER_ROLE];
        let style;

            if (key.value) {
                if (getValidAttr(key.value, ATTR_PG_ROLE)) {
                    role = key.value[ATTR_PG_ROLE];

                        if (this.isSameRole(role, key.value.ui_origRole) || key.value.project_id === PID_ALL) {
                            style = STYLE_NORMAL
                        } else {
                            style = STYLE_MODIFIED
                        }
                } else {
                    role = key.value[ATTR_USER_ROLE];
                    if(!getValidAttr(key.value, ATTR_UI_PG)) {
                        if (this.isSameRole(role, key.value.ui_origRole) || key.value.project_id === PID_ALL) {
                            style = STYLE_NORMAL
                        } else {
                            style = STYLE_MODIFIED
                        }
                    }
                }
            } else {
                role = UI_NO_ROLE;
                style = STYLE_ERROR;
            }
        let rowInd = key.row.index
        let columnId = key.column.id
        let pg = this.permGroups.find(pg => pg[ATTR_OBJ_ID] === getValidAttr(key.value, ATTR_UI_PG))
        let pgName = pg ? pg[ATTR_TEXT] : null
        return <div className={"element-set-xs"} style={style}>
            {renderPermissionElement(role, true, pgName)}
            <BasicButton
                size={"md"}
                icon={"edit"}
                action={() => {this.showMenuPromptRole(rowInd, columnId, role)}}
                title={"Muokkaa"}
            />
        </div>
    };

    // Save selected row and column id into state and enable showing a pop-up
    showMenuPromptRole(rowInd, columnId, currentRole) {
        this.setState({
            index: rowInd,
            columnId: columnId,
            currentValue: currentRole,
        }, () => this.openPopupPromptRoleMenu())
    }

    setUserNameOriginal() {
        this.userRoleList.forEach(user => {
            user.origName = user.name;
        });
    }

    async saveChangedUserPermissions() {
        let modifiedUsers = this.getModifiedUsers();
        // this.dumpUserPermissions("saveChangedUserPermissions()");
        this.setUserNameOriginal();
        if (modifiedUsers.length) {
            try {
                await this.sendDataToServer(modifiedUsers)
            } catch (e) {
                alert(e.message);
            }
        }
        return modifiedUsers.length;
    }

    async saveChangedPermissionsGroups() {
        let modifiedObjs = this.getModifiedGroupAccess()
            .concat(this.getModifiedGroup())
            .concat(this.getUpdatedPgUsers());
        if (modifiedObjs.length) {
            try {
                await this.sendDataToServer(modifiedObjs);
            } catch (e) {
                alert(e.message);
            }
        }
        return modifiedObjs.length;
    }


    removeUserGroupPermissions() {
        this.userRoleList.forEach(ur => {
            for (let key in ur) {
                if (ur.hasOwnProperty(key) && key.indexOf(PROJ_PREFIX) === 0) {
                    let userRoleObj = ur[key];
                    if (userRoleObj.hasOwnProperty(ATTR_UI_PG)) {
                        userRoleObj[ATTR_USER_ROLE] = ROLE_UNKNOWN;
                        delete(userRoleObj[ATTR_UI_PG]);
                    }
                }
            }
        })
    }

    addUsersAccessByGroup(email, groupObj) {
        let projectId = groupObj[ATTR_AWS_PROJECT_ID];
        let role = groupObj[ATTR_PG_ROLE];
        let groupId = groupObj[ATTR_PERM_GROUP];
        this.userRoleList.forEach(ur => {
            if (ur.email === email) {
                for (let key in ur) {
                    if (ur.hasOwnProperty(key) && key.indexOf(PROJ_PREFIX) === 0) {
                        let userRoleObj = ur[key];
                        if (userRoleObj[ATTR_AWS_PROJECT_ID] !== projectId) {
                            continue;
                        }
                        // when have multiple roles biggest role wins
                        if (getItmRoleSortOrder(userRoleObj) >= getItmRoleSortOrder(groupObj)) {
                            userRoleObj[ATTR_USER_ROLE] = role;
                            userRoleObj[ATTR_UI_PG] = groupId;
                            break;
                        }
                    }
                }
            }
        })
    }

    /*
    dumpUserRights(title) {
        console.log(title);
        console.table(this.userRoleList);
        this.userRoleList.forEach(ur => {
            for (let key in ur) {
                if (ur.hasOwnProperty(key) && key.indexOf(PROJ_PREFIX) === 0) {
                    let userRoleObj = ur[key];
                    let pg = "n/a";
                    let role = "??";
                    if (userRoleObj.hasOwnProperty(ATTR_UI_PG)) {
                        pg = userRoleObj[ATTR_UI_PG];
                    }
                    if (userRoleObj.hasOwnProperty(ATTR_USER_ROLE)) {
                        role = userRoleObj[ATTR_USER_ROLE];
                    }
                    console.log(key, userRoleObj.project_id, ur.email, role, pg);
                }
            }
        })
    }
   */

    addUserGroupPermissions() {
        // this.dumpUserRights("BEFORE");
        this.usersGroups.forEach((userRow, rowIndex) => {
            let email = userRow.email;
            let groupIndex = -1;
            for (let gkey in userRow) {
                if (userRow.hasOwnProperty(gkey) && gkey.indexOf(GROUP_PREFIX) === 0) {
                    groupIndex += 1;
                    let groupRow = this.pgRoleList[groupIndex];
                    for (let pkey in groupRow) {
                        if (groupRow.hasOwnProperty(pkey) && pkey.indexOf(PROJ_PREFIX) === 0) {
                            let groupObj = groupRow[pkey];
                            if (userRow[gkey] === USER_ASSIGNED_TO_GROUP) {
                                this.addUsersAccessByGroup(email, groupObj);
                                this.updateUserInPgroup(email, groupObj, true);
                            } else {
                                this.updateUserInPgroup(email, groupObj, false);
                            }
                        }
                    }
                }
            }
        });
        // this.dumpUserRights("AFTER");
    }

    updateUserGroupPermissions() {
        this.removeUserGroupPermissions();
        this.addUserGroupPermissions();
    }


    async saveChanges() {
        if (!this.hasAuthority()) {
            prosAppNotifWarn( "Ei käyttöoikeutta tai projekti on arkistoitu");
            return;
        }
        this.setState({
            isSaving: true
        });
        this.updateUserGroupPermissions();
        let numOfUserPermissions = await this.saveChangedUserPermissions();
        let numOfPermissionGroup = await this.saveChangedPermissionsGroups();
        if (numOfUserPermissions + numOfPermissionGroup) {
            prosLog("Saved numOfUserPermissions:", numOfUserPermissions,
                "numOfPermissionGroup:", numOfPermissionGroup);
            prosAppNotif("Muutokset tallennettu ");
        }
        this.saveUserGroupChanges();
        this.setState({
            isSaving: false,
            userHasModified: false
        });
    }

    renderShowSaving() {
        if (!this.state.isSaving) {
            return null
        }
        return <LoadingAnimation size={"lg"} mask />
    }

    async sendDataToServer(items) {
        prosLog("UPDATING PROJECT ACCESS ROLES");
        prosLogClearDt();
        // console.log("sendDataToServer()", items);
        await prosConnect.getActiveProject().awaitUpdateMultipleItems(items, true);
        prosLogDt("UPDATING PROJECT ACCESS ROLES COMPLETED");
    }

    hasRole(role) {
        return role !== ROLE_UNKNOWN && role !== ROLE_NONE && role !== undefined;
    }

    isSameRole(a, b) {
        if (a === b) return true;
        return (!this.hasRole(a) && !this.hasRole(b));
    }

    isDebugPid(roleObj) {
        return roleObj[ATTR_AWS_PROJECT_ID] === '3f2456e2-7fdb-417f-85d5-f49135feadc6';
    }

    /*
    dumpUserPermissions(title) {
        console.log("dumpUserPermissions()", title);
        this.userRoleList.forEach(user => {
            Object.keys(user).forEach(key => {
                if (key.indexOf(PROJ_PREFIX) === 0) {
                    let userRoleObj = user[key];
                    if (this.isDebugPid(userRoleObj) &&
                        userRoleObj.ui_origRole !== userRoleObj[ATTR_USER_ROLE]) {
                        console.log(userRoleObj[ATTR_AWS_PROJECT_ID],userRoleObj.email,
                            userRoleObj.ui_origRole, '->', userRoleObj[ATTR_USER_ROLE],
                            userRoleObj[ATTR_UI_PG]);
                    }
                }
            })
        });
    }
    */

    /**
     * Returns number of admin roles for subproject
     * @param pid       Sub project id
     * @returns {int}
     */
    numberOfAdminRoles(pid) {
        let numberOfAdmin = 0
        for (let user of this.userRoleList) {
            for (let key of Object.keys(user)) {
                if (key.indexOf(PROJ_PREFIX) !== 0) {
                    continue
                }
                let userRoleObj = user[key]
                if (pid !== userRoleObj[ATTR_AWS_PROJECT_ID]) {
                    continue
                }
                if (userRoleObj[ATTR_USER_ROLE] === ROLE_ADMIN) {
                    numberOfAdmin += 1
                }
            }
        }
        return numberOfAdmin
    }

    getModifiedUsers() {
        let modifiedUsers = [];
        this.userRoleList.forEach(user => {
            Object.keys(user).forEach(key => {
                if (key.indexOf(PROJ_PREFIX) === 0) {
                    let userRoleObj = user[key];
                    let roleChanged = !this.isSameRole(userRoleObj[ATTR_USER_ROLE], userRoleObj.ui_origRole);
                    if ((roleChanged || userRoleObj[ATTR_TEXT] !== userRoleObj.ui_OrigText) &&
                        (userRoleObj[ATTR_AWS_PROJECT_ID] !== PID_ALL)) {
                        if (userRoleObj.hasOwnProperty(ATTR_UI_PG)) {
                            // UI role is for table rendering not sent to server
                            // unless shall remove original direct permission
                            if (userRoleObj.hasOwnProperty(ATTR_UPDATED_MS_I)) {
                                userRoleObj[ATTR_OBJ_STATE] = OBJ_STATE_TO_DEL;
                                modifiedUsers.push(userRoleObj);
                                // console.log("Remove user direct role as get role from group", userRoleObj);
                            } else {
                                // ignore ui only obj
                                if (this.isDebugPid(userRoleObj)) {
                                    // console.log("Skip UI obj", userRoleObj.email, userRoleObj.obj_id, userRoleObj)
                                }
                            }
                        } else {
                            if (userRoleObj.hasOwnProperty(ATTR_OBJ_ID) || // existing
                                this.hasRole(userRoleObj)                  // modified in UI but no  role
                                ) {
                                if (userRoleObj[ATTR_OBJ_STATE] !== OBJ_STATE_CREATE || this.hasRole(userRoleObj[ATTR_USER_ROLE])) {
                                    modifiedUsers.push(userRoleObj);
                                    //console.log("role changed ",
                                    //    userRoleObj.ui_origRole, "->", userRoleObj[ATTR_USER_ROLE],
                                    //    userRoleObj.email, userRoleObj.obj_id);
                                }
                            } else {
                                if (this.isDebugPid(userRoleObj)) {
                                    // console.log("Modified in UI but no role", userRoleObj.email, userRoleObj.obj_id, userRoleObj)
                                }
                            }
                        }
                        userRoleObj.ui_origRole = userRoleObj[ATTR_USER_ROLE];
                        userRoleObj.ui_OrigText = userRoleObj[ATTR_TEXT];
                    } else {
                        // role not changed
                        if (this.isDebugPid(userRoleObj)) {
                            // console.log("Role or text not changed", userRoleObj.email, userRoleObj.obj_id)
                        }
                    }
                }
            })
        });
        return modifiedUsers;
    }

    getModifiedGroupAccess() {
        let modifiedObjs = [];
        this.pgRoleList.forEach(group => {
            Object.keys(group).forEach(key => {
                if (key.indexOf(PROJ_PREFIX) === 0 && key !== PROJ_PREFIX + '0') {
                    let groupRoleObj = group[key];
                    if (groupRoleObj.ui_origRole !== groupRoleObj[ATTR_PG_ROLE]) {
                        if (groupRoleObj[ATTR_OBJ_STATE] !== OBJ_STATE_CREATE || this.hasRole(groupRoleObj[ATTR_PG_ROLE])) {
                            modifiedObjs.push(groupRoleObj);
                        }
                        groupRoleObj.ui_origRole = groupRoleObj[ATTR_PG_ROLE];
                    }
                }
            });
        });
        return modifiedObjs;
    }

    getModifiedGroup() {
        let modifiedObjs = [];
        this.pgRoleList.forEach((group, index) => {
            if (group.origName !== group.name) {
                let permGroup = this.permGroups[index];
                permGroup[ATTR_TEXT] = group.name;
                modifiedObjs.push(permGroup);
                group.origName = group.name;
            }
        });
        return modifiedObjs;
    }

    goBack() {
        this.props.closePage();
    }

    tryingToLowerPermissionThatGetFromPermissionGroup(index, columnId, newRole) {
        let permObj = this.userRoleList[index][columnId]
        if (permObj.hasOwnProperty(ATTR_UI_PG)) {
            return getRoleSortOrder(newRole) >= getItmRoleSortOrder(permObj);
        }
        return false;
    }

    emailIsAllowedByCustomerEmailDomainConstrain(index, columnId, newRole) {
        let permObj = this.userRoleList[index][columnId]
        if (!permObj.email || newRole === ROLE_NONE) {
            return true
        }
        let errNote = this.getErrorInEmail(permObj.email)
        if (errNote) {
            prosAppNotifWarnConfirm(errNote)
            return false
        }
        return true
    }

    getProjectByColumnIdTo(projColumnId) {
        // +1 as 1st is project "ALL"
        let projectIndex = projColumnId.indexOf(PROJ_PREFIX) === 0 ?
            parseInt(projColumnId.replace(PROJ_PREFIX, "")) : -1
        return (projectIndex >= 0 && this.projects.length > 1 && projectIndex < this.projects.length) ?
            this.projects[projectIndex] : undefined
    }

    applyPgRoleForAllSubprojects(index, newRole) {
        Object.keys(this.pgRoleList[index]).forEach(projColumnId => {
            let project = this.getProjectByColumnIdTo(projColumnId)
            if (project && project.show) {
                // let projRole = this.pgRoleList[index][projColumnId][ATTR_PG_ROLE]
                // console.log('ALL: role change', projRole, '->', newRole, 'project', project );
                this.pgRoleList[index][projColumnId][ATTR_PG_ROLE] = newRole;
            }
        });
        // new role for main project column
        this.pgRoleList[index][this.state.columnId][ATTR_PG_ROLE] = newRole;
    }

    applyUserRoleForAllSubprojects(index, newRole) {
        Object.keys(this.userRoleList[index]).forEach(projColumnId => {
            let project = this.getProjectByColumnIdTo(projColumnId)
            if (project && project.show) {
                this.applyRoleForSubproject(index, projColumnId, newRole, false, true)
            }
        });
        // new role for main project column
        this.userRoleList[index][this.state.columnId][ATTR_USER_ROLE] = newRole;
    }

    applyRoleForSubproject(index, columnId, newRole, mayNotify, mayReduce) {
        let roleObj = this.userRoleList[index][columnId];
        if (!mayReduce && this.tryingToLowerPermissionThatGetFromPermissionGroup(index, columnId, newRole)) {
            if (mayNotify) {
                prosAppNotifWarn( "Ei voi alentaa, sillä oikeus tulee käyttöoikeusryhmältä");
                return false
            }
        } else if (this.emailIsAllowedByCustomerEmailDomainConstrain(index, columnId, newRole)) {
            // console.log('applyRoleForSubproject()', 'index:', index, 'columnId:', columnId, 'newRole:', newRole, 'mayNotify:', mayNotify)
            let prevRole = roleObj[ATTR_USER_ROLE];
            if (prevRole === ROLE_ADMIN && this.numberOfAdminRoles(roleObj[ATTR_AWS_PROJECT_ID]) < 2) {
                prosAppNotifWarn("Muutosta ei hyväksytty, sillä vähintään yhdellä käyttäjällä on oltava hallintaoikeus")
                return false
            }
            if (getRoleSortOrder(prevRole) > getRoleSortOrder(newRole) || mayReduce) {
                roleObj[ATTR_USER_ROLE] = newRole;
                if (roleObj.hasOwnProperty(ATTR_UI_PG)) {
                    delete roleObj[ATTR_UI_PG];
                }
                if (roleObj[ATTR_OBJ_STATE] === OBJ_STATE_TO_DEL) {
                    roleObj[ATTR_OBJ_STATE] = OBJ_STATE_ACT;
                }
                this.setState( { userHasModified: true } )
                return true
                // console.log("UI changed role for user", roleObj.email, prevRole, '->', newRole, roleObj);
            }
        }
        return false
    }


    giveNewRole(newRole) {
        prosPopupClose()
        let project = this.getProjectByColumnIdTo(this.state.columnId)

            if (this.state.mainViewMode === MAIN_VIEW_MODE_USER_PERMISSIONS) {
                if (project.projectId === PID_ALL) {
                    this.applyUserRoleForAllSubprojects(this.state.index, newRole)
                }
                else {
                    this.applyRoleForSubproject(this.state.index, this.state.columnId, newRole, true, true)
                }
            } else {
                // permission group
                this.setState( { userHasModified: true } )
                if (project.projectId === PID_ALL) {
                    this.applyPgRoleForAllSubprojects(this.state.index, newRole)
                } else {
                    this.pgRoleList[this.state.index][this.state.columnId][ATTR_PG_ROLE] = newRole;
                }
            }
        this.updateUserGroupPermissions();
        this.refreshUi();
        // this.dumpUserPermissions("After giveNewRole()")
    }

    renderNotifyPermissionByGroup(isColumnAllSubprojects) {
        if (isColumnAllSubprojects || this.state.mainViewMode !== MAIN_VIEW_MODE_USER_PERMISSIONS) {
            return
        }
        let pgObjId = this.userRoleList[this.state.index][this.state.columnId][ATTR_UI_PG]
        let pgId = pgObjId ? prosConnect.getObjListIdFromItemId(pgObjId): undefined
        let pg = this.permGroups.find(pg => pg[ATTR_OBJ_ID] === pgId)
        let pgName = pg ? pg[ATTR_TEXT] : "?"
        // console.log("pgObjId:", pgObjId, ", pgId:", pgId, ", pg:", pg, ", pgName:", pgName);
        return <>
            <div className="msg msg-notice">
                <h3>Huom! Käyttöoikeus on ryhmän "{pgName}" kautta.</h3>
                <p>Voit tarvittaessa asettaa korkeamman käyttöoikeuden.</p>
                <p>Rajoittaaksesi käyttöoikeusryhmän kautta saatua käyttöoikeutta, poista käyttäjä ensin
                    ko. ryhmästä.</p>
            </div>
            <Spacer />
        </>
    }

    alertNotAllowed() {
        if (!hasCustomerHeadMasterRole()) {
            prosAppNotifWarn("Vain asiakkaan pääkäyttäjät voivat muokata käyttöoikeusryhmiä", true, true);
            return true
        }
        return false
    }

    openPopupPromptRoleMenu() {
        if (this.state.mainViewMode === MAIN_VIEW_MODE_GROUP_PERMISSIONS) {
            // changing group role allowed only for customer head admin
            if (this.alertNotAllowed()) {
                return
            }
        }
        prosPopupOpenDynamic(this,
            'Aseta käyttöoikeus',
            () => this.promptRoleMenuHtml()
        )
    }

    promptRoleMenuHtml() {
        const makeButton =(role, disabled)=> {
            return (
                <RadioButton
                    checked={this.state.currentValue && role === this.state.currentValue}
                    key={role}
                    disabled={disabled}
                    text={getRoleForTableUi(role)}
                    onChange={() => this.giveNewRole(role)}
                />
            )
        }
        let project = this.getProjectByColumnIdTo(this.state.columnId)
        if (!project) {
            prosLogErr("No role for", this.state.columnId)
            return
        }
        let projectName = project.projectName
        let isColumnAllSubprojects = project.projectId === ALL_SUBPROJECTS
        let isPermissionFromUserGroup =
            this.state.mainViewMode !== MAIN_VIEW_MODE_GROUP_PERMISSIONS &&
            this.userRoleList[this.state.index][this.state.columnId].hasOwnProperty(ATTR_UI_PG) &&
            this.userRoleList[this.state.index][this.state.columnId][ATTR_USER_ROLE] !== ROLE_UNKNOWN
        let newRoleForText = this.state.mainViewMode === MAIN_VIEW_MODE_GROUP_PERMISSIONS ?
            <>Ryhmä: <b>{this.pgRoleList[this.state.index].name}</b></> :
            <>Käyttäjä: <b>{this.userRoleList[this.state.index].email}</b></>
        const rolesArr = [ROLE_ADMIN, ROLE_INSPECT, ROLE_REPAIR, ROLE_READER, ROLE_NONE]
        const roleSelections = rolesArr.map((role, i)=>{
           return makeButton(role, (i >= getRoleSortOrder(this.state.currentValue) && isPermissionFromUserGroup))
        })
        return <section>
            <p>{isColumnAllSubprojects ?
                ALL_SUBPROJECTS :
                <>Osaprojekti:  <b>{projectName}</b></>}</p>
            <p>{newRoleForText}</p>
            {isPermissionFromUserGroup ? this.renderNotifyPermissionByGroup(isColumnAllSubprojects) : null}
            <div className="selection-group selection-group-radio">
                {roleSelections}
            </div>
        </section>
    }


    showNameChangePopUp(index, email, name) {
        this.setState({
            rowInfo: {
                email: email,
                index: index,
                name: name,
            },
            promptName: name
        }, () => this.openPopupNameChange());
    }

    closeNameChangePopUp() {
        prosPopupClose()
        this.setState({
            rowInfo: "",
            promptName: "",
        });
    }

    handleEmailName(val) {
        this.setState(
            {
                promptEmail: val.toLowerCase().trim()
            });
    }

    handlePromptName(val) {
        this.setState({promptName: val})
    }

    getErrorInEmail(email) {
        let errText = whyEmailStringNotValid(email)
        if (errText) {
            return errText
        }
        if (prosConnect.isSuperUserOverridePermissionsInUse()) {
            return ""
        }
        let project = prosConnect.getActiveProject()
        let allowedEmailDomainStr = project.getAttr(ATTR_ALLOWED_EMAIL_DOMAINS)
        // console.log(project.getPid(), project.getAttr(ATTR_TEXT),
        //    'allowedEmailDomainStr:', allowedEmailDomainStr, 'email:', email)
        if (allowedEmailDomainStr !== STR_NO_VALUE) {
            let allowedEmailDomains = allowedEmailDomainStr.split(',')
            for (let allowedEmailDomain of allowedEmailDomains) {
                if (email.indexOf(allowedEmailDomain) >= 0) {
                    return ""
                }
            }
            return "Osoite ei sallittu, projektin asiakastiedoissa määritetty sallittuksi osoitteeksi: "
                + allowedEmailDomainStr
        }
        return ""
    }

    isPromptEmailValid() {
        let promptEmail = this.state.promptEmail
        let note = this.getErrorInEmail(promptEmail)
        if (note) {
            prosAppNotifWarn(note)
            return false
        }
        if (this.userRoleList.find(user => promptEmail === user.email)) {
            prosAppNotifWarn("Sähköpostiosoite on jo listalla");
            return false
        }
        return true
    }

    isNameValid() {
        if (this.state.promptName.length < MIN_NAME_LEN) {
            prosAppNotifWarn("Nimi on liian lyhyt, minimi " + MIN_NAME_LEN + " merkkiä");
            return false
        }
        return true;
    }

    addNewUser() {
        if (this.isPromptEmailValid() && this.isNameValid()) {
            let newUser = {
                email: this.state.promptEmail.trim().toLowerCase().split(" ").join(""),
                name: this.state.promptName,
            };
            this.createNewUser(newUser);
            prosPopupClose()
            this.setState({
                promptName: "",
                promptEmail: "",
            })
            let columnId = this.getSingleProjectColumnId()
            if (columnId && this.state.mainViewMode === MAIN_VIEW_MODE_USER_PERMISSIONS) {
                let rowInd = this.userList.length-1
                this.showMenuPromptRole(rowInd, columnId, ROLE_UNKNOWN)
            } else {
                if (this.state.mainViewMode === MAIN_VIEW_MODE_USER_PERMISSIONS) {
                    prosAppNotif("Valitse käyttöoikeudet uudelle käyttäjälle")
                } else if (this.permGroups.length < 1) {
                    prosAppNotif("Lisää käyttöoikeusryhmä ja valitse käyttäjille ryhmät")
                } else {
                    prosAppNotif("Valitse käyttöoikeusryhmä(t) uudelle käyttäjälle",)
                }
            }
        }
    }

    createNewUser(newUser) {
        this.userList.push(newUser);
        this.addUserRoleToList(newUser, true);
        this.addUserToGroup();
    }

    openPopupNewUser() {
        prosPopupOpenDynamic(this,
            'Lisää käyttäjä',
            () => this.newUserHtml()
        )
    }

    newUserHtml() {
        return <>
            <section>
                <TextInput
                    label={"Nimi"}
                    multiline={1}
                    value={this.state.promptName}
                    onChange={(val)=>this.handlePromptName(val)}
                    autoFocus
                />
                <Spacer/>
                <TextInput
                    label={"Sähköposti"}
                    isControlled
                    required
                    isValid={isValidEmail(this.state.promptEmail, true)}
                    value={this.state.promptEmail}
                    onChange={(val)=>this.handleEmailName(val)}
                />
            </section>
            <footer className={"popup-footer"}>
                <div className={"btn-set"}>
                    <CancelButton
                        action={()=> {
                            prosPopupClose()
                        }}
                    />
                    <ConfirmButton
                        label={"Lisää"}
                        action={()=> this.addNewUser()}
                        disabled={!isValidEmail(this.state.promptEmail, true)}
                    />
                </div>
            </footer>
        </>
    }

    createNewPermissionGroupId() {
        return this.customerGroup + ";" + uuidv4();
    }

    isDuplicateGroupName(name) {
        return this.permGroups.find( g => g.text.toUpperCase() === name.toUpperCase())
    }

    addNewGroup() {
        if (!this.isNameValid()) {
            return null
        }
        if (this.isDuplicateGroupName(this.state.promptName)) {
            prosAppNotifWarn("Virhe - nimi on jo käytössä")
            return null
        }
        let name = this.state.promptName;
        let newObjId = this.createNewPermissionGroupId();
        let newGroup = {};
        newGroup[ATTR_AWS_PROJECT_ID] = PRJ_PERM_GROUPS;
        newGroup[ATTR_OBJ_TYPE] = OBJ_TYPE_PRJ_PG;
        newGroup[ATTR_OBJ_ID] = newObjId;
        newGroup[ATTR_OBJ_STATE] = OBJ_STATE_CREATE;
        newGroup[ATTR_TEXT] = name;
        this.permGroups.push(newGroup);
        let newPgRow = {
            name: name,
        };
        newPgRow[ATTR_OBJ_ID] = newObjId;
        this.addPgRoleToList(newPgRow, true);
        prosPopupClose()
        this.setState({promptName: ""});
        this.setState( { userHasModified: true } )
    }

    openPopupNewGroup() {
        prosPopupOpenDynamic(this,
            'Uusi käyttöoikeusryhmä',
            () => this.newGroupHtml()
        )
    }

    newGroupHtml() {
        return <>
            <section>
                <TextInput
                    label={"Nimi"}
                    multiline={1}
                    value={this.state.promptName}
                    onChange={(val)=>this.handlePromptName(val)}
                />
            </section>
            <footer className={"popup-footer"}>
                <div className={"btn-set"}>
                    <CancelButton
                        action={()=> prosPopupClose()}
                    />
                    <ConfirmButton
                        label={"Lisää"}
                        action={()=> this.addNewGroup()}
                    />
                </div>
            </footer>
        </>
    }

    changeName() {
        if (this.state.mainViewMode === MAIN_VIEW_MODE_USER_PERMISSIONS) {
            this.userRoleList[this.state.rowInfo.index].name = this.state.promptName;
            this.userRoleList.forEach(user => {
                Object.keys(user).forEach(key => {
                    if (key.indexOf(PROJ_PREFIX) === 0) {
                        let userRoleObj = user[key];
                        if (userRoleObj.email === this.userRoleList[this.state.rowInfo.index].email) {
                            userRoleObj[ATTR_TEXT] = this.state.promptName;
                        }
                    }
                })
            });
        } else if (this.state.mainViewMode === MAIN_VIEW_MODE_GROUP_PERMISSIONS) {
            this.pgRoleList[this.state.rowInfo.index].name = this.state.promptName;
        }
        prosPopupClose()
        this.setState({
            promptName: "",
            userHasModified: true
        });
    }

    openPopupNameChange() {
        prosPopupOpenDynamic(this,
            'Vaihda nimi',
            this.nameChangeHtml,
            () => this.closeNameChangePopUp()
        )
    }

    nameChangeHtml(ui) {
        return <>
            <section>
                <TextInput
                    label={"Kirjoita nimi"}
                    value={ui.state.promptName}
                    onChange={(val)=>ui.handlePromptName(val)}
                />
            </section>
            <footer className={"popup-footer"}>
                <div className={"btn-set"}>
                    <CancelButton
                        action={()=> ui.closeNameChangePopUp()}
                    />
                    <ConfirmButton
                        action={()=> ui.changeName()}
                        disabled={(ui.state.promptName.length < 1)}
                    />
                </div>
            </footer>
        </>
    }

    renderProjectPermissionsTable() {
        let mainColumns;
        let mainData;
        let projectColumns =
            this.projects
                .filter(project => project.show)
                .map(project => {
                        return {
                            Header: project.projectName,
                            id: project.id,
                            accessor: project.id,
                            Cell: this.renderRole,
                            minWidth: 100,
                            filter: 'filterRole',
                            sortType: 'roleSort',
                        }
                    })


        if (this.state.mainViewMode === MAIN_VIEW_MODE_USER_PERMISSIONS) {
            mainData = this.userRoleList;
            mainColumns = [
                {
                    Header: NAME_COL_TITLE,
                    accessor: "name",
                    minWidth: COL_WIDTH_NAME,
                    Cell: this.renderName,
                    filter: 'text'
                },
                {
                    Header: EMAIL_COL_TITLE,
                    accessor: ATTR_EMAIL,
                    minWidth: COL_WIDTH_EMAIL,
                    Cell: this.renderEmail,
                    filter: 'text',
                    className: 'sticky',
                }
        ]

        } else {
            mainData = this.pgRoleList;
            mainColumns = [
                {
                    Header: NAME_COL_PG_NAME,
                    accessor: "name",
                    Cell: this.renderName,
                    minWidth: COL_WIDTH_NAME,
                }
            ]
        }
        return <>
            <div className={"table-container"}>
                {this.renderSelectAndFilterProject()}
                <PermissionsTable
                    data={mainData}
                    columns={mainColumns.concat(projectColumns)}
                    showPagination={false}
                    minRows={0}
                    sortable={true}
                />
            </div>
                <Spacer size={"lg"}/>
                {this.renderBottomButtons()}
            </>
    }

    renderBottomButtons() {
        let addUser = null
        let addPermissionGroup = null
        if (hasCustomerHeadMasterRole() ||
            (this.state.mainViewMode !== MAIN_VIEW_MODE_GROUP_USERS)) {
            addUser = <BasicButton
                btnClass={"2nd"}
                label={"Lisää käyttäjä"}
                icon={"user-add"}
                action={() => this.openPopupNewUser()}
            />
        }
        if (hasCustomerHeadMasterRole() &&
            this.state.mainViewMode === MAIN_VIEW_MODE_GROUP_USERS) {
            addPermissionGroup = <BasicButton
                btnClass={"2nd"}
                icon={"plus"}
                label={"Uusi käyttöoikeusryhmä"}
                action={() => {
                    this.openPopupNewGroup()
                }}
                disabled={!prosConnect.hasCustomerHeadMasterRole()}
            />
        }

        return <div>
            {addUser || addPermissionGroup ?
                <div className={"grid-container grid-1 grid-2_md width-70_lg width-50_xl width-30_xxl"}>
                    {addUser}
                    {addPermissionGroup}
                </div> : null}
        </div>
    }

    renderSaveCancelButtons(){
        if(!this.state.userHasModified) return null
        return <footer className={"page-footer"}>
                <div className={"btn-set_center"}>
                    <CancelButton
                        action={()=> this.goBack()}
                    />
                    <ConfirmButton
                        action={()=> this.saveChanges()}
                        disabled={this.state.isSaving}
                    />
                </div>
            </footer>
    }

    toggleUserGroup(key, currentTxt) {
        if (this.alertNotAllowed()) { return }
        let index = key.row.index;
        let columnId = key.column.id;
        this.setState( { userHasModified: true } )
        if (this.usersGroups[index][columnId] === USER_ASSIGNED_TO_GROUP) {
            this.usersGroups[index][columnId] = USER_NOT_ASSIGNED_TO_GROUP
        } else {
            this.usersGroups[index][columnId] = USER_ASSIGNED_TO_GROUP
        }
        this.updateUserGroupPermissions();
        this.refreshUi();
    }

    saveOriginalGroup(index, columnId, value) {
        let key = columnId + "/" + index;
        this.savedGroupOriginal[key] = value;
    }

    isGroupChanged(index, columnId, value) {
        let key = columnId + "/" + index;
        if (this.savedGroupOriginal.hasOwnProperty(key)) {
            return this.savedGroupOriginal[key] !== value;
        }
        return true;
    }

    saveUserGroupChanges() {
        this.usersGroups.forEach((row, rowIndex) => {
            let columnId = 0;
            Object.keys(row).forEach(key => {
                if (key.indexOf(GROUP_PREFIX) === 0) {
                    let value = row[key];
                    this.saveOriginalGroup(rowIndex, GROUP_PREFIX + columnId, value);
                    columnId += 1;
                }
            });
        })
    }


    onFilterTextChanged(val) {
        this.setState({ filterTextInput: val});
    }

    renderSearchButton(title, helpText, showTextFilter) {
        if (!showTextFilter) return null
        return <TimerTextInput
            placeholder={title}
            value={this.state.filterTextInput}
            timerCallback={(val)=> {
                this.onFilterTextChanged(val)
            }}
            info={this.state.filterTextInput.length > 0 ? helpText : null}
        />
    }

    renderUSerInGroup = (key) => {
        let txt;
        let style;
        if (key.value) {
            txt = key.value;
            let index = key.row.index;
            let columnId = key.column.id;
            let isGroupChanged = this.isGroupChanged(index, columnId, txt);
            style = isGroupChanged ? STYLE_IN_GROUP_MODIFIED: STYLE_IN_GROUP;
        } else {
            txt = "?";
            style = STYLE_ERROR;
        }
        // console.log("renderUSerInGroup() index", index, "columnId", columnId, "original", original, "txt", txt);
        return <p
            style={style}
            onClick={() => {this.toggleUserGroup(key, txt)}}>
            {txt}</p>
    };

    renderUserGroupsTable() {
        let pgColumns = [];
        this.permGroups.forEach((pg, i) => {
            let permGroupName = pg.text;
            if (prosMultiFilterText(this.state.filterTextInput, permGroupName)) {
                pgColumns.push({
                    Header: pg.text,
                    id: GROUP_PREFIX + i,
                    accessor: (GROUP_PREFIX + i),
                    Cell: this.renderUSerInGroup
                });
            }
        });

        let columns = [
            {
                Header: NAME_COL_TITLE,
                accessor: "name",
                Cell: this.renderName,
                minWidth: COL_WIDTH_NAME,
                filter: 'text'
            },
            {
                Header: EMAIL_COL_TITLE,
                accessor: ATTR_EMAIL,
                Cell: this.renderEmail,
                minWidth: COL_WIDTH_EMAIL,
                filter: 'text'
            }
        ].concat(pgColumns)

        return <>
                    <div className={"table-container"}>
                        {this.renderSelectAndFilterProject()}
                        <PermissionsTable
                            data={this.usersGroups}
                            columns={columns}
                            showPagination={false}
                            minRows={0}
                            sortable={true}
                        />
                    </div>
                    {this.renderBottomButtons()}
            </>
    }

    refreshUi() {
        this.setState( {
            refresh: this.state.refresh+1,
        });
    }

    getViewTypeName(mode) {
        switch (mode) {
            case MAIN_VIEW_MODE_USER_PERMISSIONS: return "Käyttäjän oikeudet"
            case MAIN_VIEW_MODE_GROUP_PERMISSIONS: return "Ryhmän oikeudet"
            case MAIN_VIEW_MODE_GROUP_USERS:
            default:  return "Käyttöoikeusryhmät"
        }
    }

    renderViewModeButton(mode) {
        if (this.props.showSingleSubProject) {
            return null
        }
        let label = this.getViewTypeName(mode);
        return (
            <span
                onClick={() => {this.setState({mainViewMode: mode})}}
                className={mode === this.state.mainViewMode ? "active" : null}
                key={mode}
            >
                <p>{label}</p>
            </span>
        )
    }

    renderSubProjectTitle(){
        if(!this.props.showSingleSubProject) return null
        return <>
                <i className={"ui-icon ui-icon-md ui-icon-chevron-right"}/>
                {prosConnect.getActiveSubProjectName()}
                {prosConnect.getActiveProject().attrs[ATTR_OBJ_STATE] === OBJ_STATE_PAS &&
                    <span className={"color-2nd"}>
                        <i className={"ui-icon ui-icon-md ui-icon-outline-lock ui-icon_color-2nd"} />Arkistoitu
                    </span>}
            </>
    }

    renderPageTitle() {
        if (this.props.showGroupsOnly) {
            return <h1>Käyttöoikeusryhmät</h1>
        }
        let pageTitle = this.props.showSingleSubProject ?
            "Osaprojektin käyttöoikeudet":
            "Projektin käyttöoikeudet"
        return <h1>{pageTitle}</h1>
    }

    renderNaviTabs() {
        if (this.props.showSingleSubProject || this.props.showGroupsOnly) {
            return null
        }
        const linkArr = [MAIN_VIEW_MODE_USER_PERMISSIONS, MAIN_VIEW_MODE_GROUP_PERMISSIONS, MAIN_VIEW_MODE_GROUP_USERS]
        let linkValues = linkArr.map((phase, i) => {
            return {
                value: i,
                text: this.getViewTypeName(phase),
                selected: this.state.mainViewMode === phase,
            }
        })
        return <TabsNavigation values={linkValues}
           callback={(val)=> this.setState({mainViewMode: linkArr[val]})}
           className={"padding-top"}
        />
    }

    renderCustomerHeadMasters() {
        let customerHeadMasters = prosConnect.getActiveProject().getAttr(ATTR_CUSTOMER_ADMIN_EMAILS)
        if (this.state.mainViewMode === MAIN_VIEW_MODE_USER_PERMISSIONS ||!customerHeadMasters) {
            return null
        }
        let alertNoGroups = this.permGroups.length < 1 ? <p>Asiakkalla ei ole käyttöoikeusryhmiä</p> : null
        return <section>
            <p>
            {"Ryhmiä voivat muokata asiakkaan asetuksissa pääkäyttäjät: " + customerHeadMasters.replaceAll(',', ', ')}
            </p>
            {alertNoGroups}
        </section>
    }

    renderSelectAndFilterProject() {
        let searchInput = null
        if (this.state.mainViewMode === MAIN_VIEW_MODE_GROUP_USERS) {
            searchInput = this.renderSearchButton(
                "Käyttäjäryhmän rajaus",
                "Käytä pilkkua, jos haluat hakea useita käyttäjäryhmiä",
                true
            )
        } else {
            searchInput = <>
                {this.renderSearchButton(
                    "Projektinimen rajaus",
                    "Käytä pilkkua, jos haluat hakea useita projekteja",
                    !(this.props.showSingleSubProject || this.props.showGroupsOnly)
                )}
            </>
        }
        return <div className="table-controls">
            <div className="table-options width-100 width-40_lg">
                {this.renderCustomerHeadMasters()}
                {searchInput}
            </div>
            <div className="view-options"/>
        </div>
    }

    renderMainView() {
        let view
        switch(this.state.mainViewMode) {
            case MAIN_VIEW_MODE_USER_PERMISSIONS: view = this.renderProjectPermissionsTable(); break;
            case MAIN_VIEW_MODE_GROUP_PERMISSIONS: view = this.renderProjectPermissionsTable(); break;
            case MAIN_VIEW_MODE_GROUP_USERS: view = this.renderUserGroupsTable(); break;
            default: view = <h2>{"Unknown mainViewMode " + this.state.mainViewMode}</h2>
        }
        return(
            <section className={"table-view table-view-permissions"}>
                {view}
            </section>
        )
    }

    render() {
        if (this.state.isLoading) {
            return <LoadingAnimation size={"lg"} />
        }
        if (!this.hasAuthority()) {
            return <div className={"mini-page"}>
                <header>
                    <h1>Ei käyttöoikeuksia - selain on käynnistetty</h1>
                </header>
                <footer>
                    <BasicButton
                        btnClass={"2nd"}
                        size={"md"}
                        action={() => this.goBack()}
                        label="Takaisin"
                    />
                </footer>
            </div>
        }
        require("../containers/assets/scss/views/Table.scss");
        this.filterProjects()
        return <>
            {this.renderPageTitle()}
            {this.renderNaviTabs()}
            {this.renderMainView()}
            {this.renderSaveCancelButtons()}
            {this.renderShowSaving()}
            {prosPopupRender(this, "PermissionManagement")}
        </>
    }
}